import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';

import GuidedTour from 'components/common/GuidedTour/GuidedTour';

export const SHOW_HOME_GUIDED_TOUR_KEY = '3pp_show_home_guided_tour';

export const HomeGuidedTour = props => {
  const { t, setTriggerGuidedTour, isMobile, createNewButtonRef } = props;
  const [guidedTourSteps, setGuidedTourSteps] = useState([]);

  useEffect(() => {
    const steps = [];
    isMobile &&
      steps.push(
        {
          target: '.guided-tour-my-profile',
          title: t('guidedTour.header.myProfile.title'),
          content: t('guidedTour.header.myProfile.content'),
          placement: 'right',
          floaterProps: {
            styles: {
              floater: {
                width: 370
              }
            }
          },
          disableBeacon: true
        },
        {
          target: '.guided-tour-hamburger-menu',
          title: t('guidedTour.header.hamburgerMenu.title'),
          content: t('guidedTour.header.hamburgerMenu.content'),
          placement: 'top',
          floaterProps: {
            styles: {
              floater: {
                marginTop: 8,
                marginLeft: 30
              }
            }
          },
          disableBeacon: true
        }
      );
    isMobile &&
      createNewButtonRef.current &&
      steps.push({
        target: '.create-new-button',
        title: t('guidedTour.home.createNew.title'),
        content: t('guidedTour.home.createNew.content'),
        placement: 'bottom-start',
        floaterProps: {
          disableFlip: true,
          styles: {
            floater: {
              width: 340
            },
            arrow: {
              display: 'none'
            }
          }
        },
        styles: {
          spotlight: {
            border: '4px solid #004170',
            marginRight: 30
          }
        }
      });

    !isMobile &&
      steps.push(
        {
          target: '.guided-tour-my-profile',
          title: t('guidedTour.header.myProfile.title'),
          content: t('guidedTour.header.myProfile.content'),
          placement: 'right',
          floaterProps: {
            styles: {
              floater: {
                marginRight: -12
              }
            }
          },
          disableBeacon: true
        },
        {
          target: '.guided-tour-hamburger-menu',
          title: t('guidedTour.header.hamburgerMenu.title'),
          content: t('guidedTour.header.hamburgerMenu.content'),
          placement: 'top',
          floaterProps: {
            styles: {
              floater: {
                marginTop: 8,
                marginLeft: 30
              }
            }
          },
          disableBeacon: true
        },
        {
          target: 'th:nth-of-type(2) .CellLayout-container',
          title: t('guidedTour.home.grid.title'),
          content: t('guidedTour.home.grid.content'),
          placement: 'right-start',
          floaterProps: {
            disableFlip: true,
            styles: {
              floater: {
                minWidth: 500
              },
              arrow: {
                display: 'none'
              }
            }
          },
          styles: {
            spotlight: {
              border: '4px solid #004170',
              height: 46,
              maxHeight: 46,
              width: '11.4%',
              maxWidth: '11.4%'
            }
          }
        }
      );

    !isMobile &&
      createNewButtonRef.current &&
      steps.push({
        target: '.create-new-button',
        title: t('guidedTour.home.createNew.title'),
        content: t('guidedTour.home.createNew.content'),
        placement: 'left-start',
        floaterProps: {
          disableFlip: true,
          styles: {
            floater: {
              minWidth: 500
            },
            arrow: {
              display: 'none'
            }
          }
        },
        styles: {
          spotlight: {
            border: '4px solid #004170'
          }
        },
        spotlightPadding: 20
      });

    setGuidedTourSteps(steps);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createNewButtonRef]);

  const onTourComplete = isDone => {
    if (isDone) {
      localStorage.setItem(SHOW_HOME_GUIDED_TOUR_KEY, false);
      setTriggerGuidedTour();
    }
  };

  return (
    <GuidedTour
      onTourComplete={onTourComplete}
      steps={guidedTourSteps}
      totalSteps={guidedTourSteps?.length}
      locale={{
        next: t('guidedTour.next'),
        back: t('guidedTour.back'),
        last: t('guidedTour.last'),
        skip: t('guidedTour.skip'),
        close: t('guidedTour.close')
      }}
    />
  );
};

export default withTranslation()(HomeGuidedTour);
